import { render, staticRenderFns } from "./exresults.vue?vue&type=template&id=08a7fdf0&scoped=true&"
import script from "./exresults.vue?vue&type=script&lang=js&"
export * from "./exresults.vue?vue&type=script&lang=js&"
import style0 from "./exresults.vue?vue&type=style&index=0&id=08a7fdf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7fdf0",
  null
  
)

export default component.exports